import { Actions } from './fournisseurActions';

/**
 * Etat initial
 */
const initialState = {
    suggestions: {
        items: [],
        isLoading: false,
        value: '',
        selectedId: 0
    },
    fournisseurs: {
        items: [],
        isLoading: false
    }
};

/**
 * Reducer pour le domaine "fournisseur"
 */
const reducer = (namespace)=> (state = initialState, action) => {

    switch (action.type) {

        case `${namespace}/${Actions.FETCH_FOURNISSEURS_REQUEST}`:
            return {
                ...state,
                fournisseurs: { ...state.fournisseurs, isLoading: true }
            };

        case `${namespace}/${Actions.FETCH_FOURNISSEURS_SUCCESS}`:
            return {
                ...state,
                fournisseurs: { ...state.fournisseurs, items: [...action.items], isLoading: false }
            };

        case `${namespace}/${Actions.FETCH_FOURNISSEURS_FAILURE}`:
            return {
                ...state,
                fournisseurs: { ...state.fournisseurs, isLoading: false, error: action.error }
            };

        case `${namespace}/${Actions.FETCH_SUGGESTIONS_FOURNISSEUR_REQUEST}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, isLoading: true }
            };

        case `${namespace}/${Actions.FETCH_SUGGESTIONS_FOURNISSEUR_SUCCESS}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, items: [...action.fournisseurs], isLoading: false }
            };

        case `${namespace}/${Actions.FETCH_SUGGESTIONS_FOURNISSEUR_FAILURE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, isLoading: false, error: action.error }
            };
        
        case `${namespace}/${Actions.CLEAR_SUGGESTIONS_FOURNISSEUR}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, items: [], isLoading: false }
            };

        case `${namespace}/${Actions.SET_FOURNISSEUR_VALUE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, value: action.value, selectedId: action.selectedId }
            };

        case `${namespace}/${Actions.CLEAR_FOURNISSEUR_VALUE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, value: '', selectedId: 0 }
            };


        default:
    }

    return state;
};

export default reducer;